<template>
  <div>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title>{{
          $t("animal.geneticWorthInfo.geneticWorth")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          large
          :to="{
            name: 'AnimalGenWorthEdit',
            params: { animal_number: $route.params.animal_number },
          }"
        >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <!-- <v-btn
                icon
                large
            >
            <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->
      </v-toolbar>
    </v-card>
    <v-card flat class="mt-7">
      <v-card-text>
        <div class="tabs-section">
          <template>
            <v-tabs class="tabs-pill" v-model="tab">
              <v-tab>{{ $t("animal.geneticWorthInfo.tools") }}</v-tab>
              <v-tab>{{ $t("animal.geneticWorthInfo.trait") }}</v-tab>
              <v-tab>{{ $t("animal.geneticWorthInfo.economicIndex") }}</v-tab>
            </v-tabs>
          </template>
        </div>
        <v-tabs-items v-model="tab">
          <v-tab-item> <tools /> </v-tab-item>
          <v-tab-item> <traits /> </v-tab-item>
          <v-tab-item> <economic-index /> </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import AnimalService from "@/_services/AnimalService";

import EconomicIndex from "./geneticworth/EconomicIndex.vue";
import Tools from "./geneticworth/Tools.vue";
import Traits from "./geneticworth/Traits.vue";
// import { geneticWorth } from "@/graphql/GeneticWorth.gql";
export default {
//   apollo: {
//     geneticWorth: {
//       query: geneticWorth,
//       variables() {
//         return {
//           animalId: parseInt(this.$route.params.animal_number),
//         };
//       },
//     },
//   },
  components: {
    Tools,
    Traits,
    EconomicIndex,
  },
  mounted() {},
  data() {
    return {
      animal: {},
      tab: null,
    };
  },

  methods: {
    getSingleAnimalData(animalId) {
      AnimalService.getSingleAnimal(animalId)
        .then((res) => {
          this.animal = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>
